import { render, staticRenderFns } from "./LedesFoldersList.vue?vue&type=template&id=6270fe5c&"
import script from "./LedesFoldersList.vue?vue&type=script&lang=js&"
export * from "./LedesFoldersList.vue?vue&type=script&lang=js&"
import style0 from "./LedesFoldersList.vue?vue&type=style&index=0&id=6270fe5c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports